import apollo from 'apollo';
import store from 'store';

import { AsyncActionHandler } from 'action-handler';
import { pageLayoutQuery } from 'queries';
import { createNormalizedMap, handleFetchError } from 'action-utils';

import { hidenCollectionsIds } from '../../config';

export default new AsyncActionHandler({
  name: 'fetch_page_layout',
  stateProp: 'fetchPageLayout',
  defaultState: {
    pageLayoutItems: {}
  },
  handler(type, { id, limit } = {}) {
    return async () => {
      const galleryState = store.getState().gallery;
      const { gregEnabled } = galleryState.experiments;

      let pageLayoutItems;
      try {
        const { data } = await apollo.query({
          query: pageLayoutQuery,
          variables: {
            id,
            type,
            limit
          }
        });
        pageLayoutItems = data.pageLayout;
        if (!gregEnabled) {
          pageLayoutItems = pageLayoutItems.filter((el) => {
            // if layout does not have a link it's not an app/clock collection
            if (el.link) {
              return !hidenCollectionsIds.includes(el.link.resourceId);
            }
            return true;
          });
        }
      } catch (error) {
        return handleFetchError(error);
      }

      return {
        appType: type,
        pageLayoutItems
      };
    };
  },
  reduce: (state, { pageLayoutItems, appType }) => ({
    pageLayoutItems: {
      ...state.pageLayoutItems,
      [appType]: pageLayoutItems
    },
    apps: {
      ...state.apps,
      ...createNormalizedMap(
        pageLayoutItems.reduce(
          (apps, item) => apps.concat(item.apps || []),
          []
        ),
        state.apps
      )
    }
  })
});
